// TelcoTrack - Login Component
// Handles user authentication with form validation

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    // Already signed in — open the Dashboard přehled.
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/dashboard', { replaceUrl: true }).catch(() => {
        this.router.navigateByUrl('/maps', { replaceUrl: true });
      });
    }
  }

  async onSubmit(): Promise<void> {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';

      // Login user
      const { email, password } = this.loginForm.value;
      try {
        const success = await firstValueFrom(this.authService.login(email, password));
        if (success) {
          // Dashboard přehled. replaceUrl keeps the back button off the login page.
          this.router.navigateByUrl('/dashboard', { replaceUrl: true }).catch(() => {
            this.router.navigateByUrl('/maps', { replaceUrl: true });
          });
        }
      } catch (error) {
        this.errorMessage = error instanceof Error ? error.message : 'Login failed. Please check your credentials.';
      } finally {
        this.isLoading = false;
      }
    } else {
      this.markFormGroupTouched();
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.loginForm.controls).forEach(key => {
      const control = this.loginForm.get(key);
      control?.markAsTouched();
    });
  }

  getFieldError(fieldName: string): string {
    const field = this.loginForm.get(fieldName);
    if (field?.errors && field.touched) {
      if (field.errors['required']) {
        return 'Toto pole je povinné';
      }
      if (field.errors['email']) {
        return 'Zadejte platnou emailovou adresu';
      }
      if (field.errors['minlength']) {
        return 'Heslo musí mít alespoň 6 znaků';
      }
    }
    return '';
  }
}
